import React, { createContext, useContext, useEffect, useState } from 'react';

const VehiclesContext = createContext(null);

function getApiBase() {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:4000';
  }
  return '';
}

export function VehiclesProvider({ children }) {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const apiBase = getApiBase();
    const url = `${apiBase}/api/v1/stock`;

    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to load stock (${res.status})`);
        }
        return res.json();
      })
      .then((json) => {
        setVehicles(Array.isArray(json?.results) ? json.results : []);
      })
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <VehiclesContext.Provider value={{ vehicles, loading, error }}>
      {children}
    </VehiclesContext.Provider>
  );
}

export function useVehicles() {
  const context = useContext(VehiclesContext);
  if (!context) {
    throw new Error('useVehicles must be used within VehiclesProvider');
  }
  return context;
}
